import { Currency } from '../enums/currency-enum';
import { Locale } from '../enums/locale-enum';

/**
 * Mapping of Currency enum values to their corresponding Locale values.
 */
const currencyLocaleMap: { [key in Currency]: Locale } = {
  [Currency.USD]: Locale.EN_US, // US Dollars
  [Currency.CAD]: Locale.EN_CA, // Canadian Dollar
  [Currency.AUD]: Locale.EN_AU, // Australian Dollar
  [Currency.EUR]: Locale.EN_FR, // Euro
  [Currency.GBP]: Locale.EN_UK, // British Pound
  [Currency.JPY]: Locale.JA_JP, // Japanese Yen
  [Currency.KRW]: Locale.EN_KR, // South Korean Won
};

/**
 * Retrieves the currency symbol for a given ISO code.
 * @param isoCode The ISO code of the currency.
 * @returns The currency symbol.
 */
export function getCurrencySymbol(currency: Currency): string {
  if (!Object.values(Currency).includes(currency)) {
    return '';
  }

  return (
    new Intl.NumberFormat(getLocaleForCurrency(currency), {
      style: 'currency',
      currency,
    })
      .formatToParts(1)
      .find((x) => x.type === 'currency')?.value || ''
  );
}

/**
 * Retrieves the locale for a given currency.
 * @param currency The currency.
 * @returns The locale.
 */
export function getLocaleForCurrency(currency: Currency): Locale | undefined {
  if (!Object.values(Currency).includes(currency)) {
    return Locale.EN_US;
  }

  return currencyLocaleMap[currency];
}
